export default "__VITE_ASSET__BretGIGP__"